import React from 'react';
import { InfoIcon, ToggleLeftIcon, ToggleRightIcon } from 'lucide-react';
export const TopBar = ({
  showVat,
  setShowVat
}) => {
  return <header className="bg-white shadow-sm w-full" data-id="element-247">
      <div className="container mx-auto px-4 py-4" data-id="element-248">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-249">
          <div data-id="element-250">
            <h1 className="text-2xl font-bold text-gray-800" data-id="element-251">
              Tilbud til Andersen & Søn ApS
            </h1>
            <div className="flex flex-wrap gap-2 mt-2" data-id="element-252">
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-253">
                Projekt: Villa 180 m²
              </span>
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-254">
                Quote-ID: Q-2025-0417
              </span>
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-255">
                Gyldig til: 30.09.2025
              </span>
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-256">
                Kontakt: Morten Hansen
              </span>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto" data-id="element-257">
            <button className="flex items-center justify-center gap-2 px-4 py-2 rounded-md bg-white border border-gray-200 text-sm font-medium" onClick={() => setShowVat(!showVat)} data-id="element-258">
              {showVat ? <ToggleRightIcon className="h-4 w-4 text-green-600" data-id="element-259" /> : <ToggleLeftIcon className="h-4 w-4 text-gray-400" data-id="element-260" />}
              Vis {showVat ? 'inkl.' : 'ekskl.'} moms
            </button>
            <div className="flex items-center gap-2 px-4 py-2 rounded-md bg-blue-50 text-blue-700 text-sm" data-id="element-261">
              <InfoIcon className="h-4 w-4" data-id="element-262" />
              <span data-id="element-263">Forberedt i ekstern kilde • 20.06.2025 14:35</span>
            </div>
          </div>
        </div>
      </div>
    </header>;
};